import React, { Component } from "react"
import { Link } from "gatsby"
// import AnchorLink from 'react-anchor-link-smooth-scroll';

import Layout from "../components/layout"
import SEO from "../components/seo"

import SimpleModal from "../components/utilities/SimpleModal"

import "./casestudylifesyncthree.scss"

import imgQuote from "../images/quotation_mark.webp"

export default ({ pageContext }) => (
  <Layout>
    <SEO
      title={pageContext.yoast.title}
      description={pageContext.yoast.metadesc}
      ogimg={pageContext.yoast.opengraph_image}
      link={pageContext.link}
    />
    <div className="case-study-lifesyncthree-wrapper">
      <div className="container-fluid">
        <div className="row">
          <div
            className="header-container"
            style={{
              backgroundImage: `url(${pageContext.acf.header_image.csOneHedImaLocalFile.childImageSharp.fluid.src})`,
            }}
          >
            <img src={imgQuote} alt="" />
            <h2>{pageContext.acf.header_text}</h2>
          </div>
        </div>
      </div>
      <div className="container detail-wrapper">
        <div className="row">
          <div className="col-md-8">
            <img
              src={
                pageContext.acf.client_logo.csOneCliLogLocalFile.childImageSharp.fluid.src
              }
              className="client-logo"
              width={pageContext.acf.client_logo.media_details.width / 1.5}
              height={pageContext.acf.client_logo.media_details.height / 1.5}
              alt={pageContext.yoast.opengraph_title}
            />
          </div>
          <div className="col-md-4">
            <a
              href="https://www.meritmile.com/uploads/2026/08/lifesync-3-0-case-study.pdf"
              className="btn downloadBtn"
              target="_blank"
              rel="nofollow noopener noreferrer"
              style={{ marginTop: "4em" }}
            >
              Download the PDF here
            </a>
          </div>
          <div className="col-12">
            <div className="bar"></div>
          </div>
          <div className="col-12">
            <div
              className="first-paragraph"
              dangerouslySetInnerHTML={{
                __html: pageContext.acf.first_paragraph,
              }}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-12 text-center">
            <img
              src="https://www.meritmile.com/uploads/2026/08/lifesync-3-intro.webp"
              className="results-image img-fluid"
              alt="LifeSync Intro"
              width="1400px"
              style={{
                marginTop: "2em",
                marginBottom: "6em",
                transform: "scale(1.2)",
              }}
            />
          </div>
        </div>
        <div className="row margin-b">
          <div className="col-12">
            <p>Bringing that vision to market required more than a new look. <b>LifeSync needed a cohesive expression of who it had become</b>: one company with two distinct lines of business, a growing portfolio of innovations, and the global resources of Amphenol behind it.</p>
            <p>Building on <a href="/case-studies/lifesync/">years of collaboration and trust</a>, with a deep understanding of LifeSync's business and market, Merit Mile worked alongside LifeSync to develop and launch LifeSync 3.0, an integrated brand transformation spanning messaging and positioning, visual identity, customer-facing collateral, digital experiences, and original photography and video. Every element needed to work together—giving healthcare organizations and OEMs a clearer understanding of LifeSync’s capabilities and a more intuitive path to the solutions relevant
to them.</p>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <div
              className="third-paragraph"
              dangerouslySetInnerHTML={{
                __html: pageContext.acf.third_paragraph,
              }}
            />
          </div>
        </div>
        <div className="row margin-b">
          <div className="col-12 col-md-6">
            <p>
              As LifeSync's business and portfolio evolved, its brand experience needed to evolve in order to clearly distinguish these audiences and communicate the depth of LifeSync's capabilities. Messaging, collateral, and digital content needed a clearer hierarchy, while the website needed to help visitors self-select based on the problems they were trying to solve. LifeSync also needed to incorporate its relationship with Amphenol more visibly and bring ReLife—its closed-loop ECG leadwire reprocessing solution, which Merit Mile <a href="https://lifesync.com/pages/relife" target="_blank">also launched</a>—into the broader portfolio without diminishing its distinct value.
            </p>
            <p>
                Merit Mile partnered with LifeSync to create a brand system that was disciplined enough for a highly regulated medical manufacturer, flexible enough to support distinct customer journeys, and unmistakably owned by LifeSync across every interaction.
            </p>
          </div>
          <div className="col-12 col-md-6">
            <img
              src="https://www.meritmile.com/uploads/2026/08/lifesync-3-challenge.webp"
              className="results-image img-fluid"
              alt="LifeSync Challenge"
              width="800px"
              style={{
                marginTop: "1em",
                marginBottom: "4em",
              }}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-12 text-center">
            <img
              src="https://www.meritmile.com/uploads/2026/08/lifesync-lab.webp"
              className="results-image img-fluid"
              alt="LifeSync Solutions"
              width="1400px"
              style={{
                marginTop: "2em",
                marginBottom: "6em",
                transform: "scale(1.2)",
              }}
            />
          </div>
        </div>
        <div className="row margin-b">
          <div className="col-12">
            <h3>Solutions</h3>
            <p>
              <b>Messaging</b><br />
              Merit Mile began at the foundation with messaging and positioning. Working directly with LifeSync leadership, the story behind LifeSync 3.0 started to come to life. Those conversations shaped a comprehensive messaging and positioning framework that defines <em>why LifeSync</em>, tells an ownable and differentiated story, and establishes distinct positioning for its two lines of business—LifeSync Patient Connections and LifeSync Advanced Manufacturing.
            </p>
          </div>
        </div>
    </div>
    <div className="container-fluid" style={{ background: 'url("https://www.meritmile.com/uploads/2026/08/lifesync-waves-bg.webp") no-repeat right -600px'}}>
        <div className="container detail-wrapper">
            <div className="row margin-b">
                <div className="col-12 col-md-6">
                    <p>
                        <b>Visual Identity</b><br />
                        That messaging then informed a new visual identity where Merit Mile reimagined the brand with a refreshed visual language that balanced clinical precision with vitality. Built around distinguishable deep blue and mint green colors, fluid lines, and points of light gave visual form to the connections LifeSync enables, while rounded imagery and a warm, modern typeface made the system feel approachable and distinctly human.
                    </p>
                    <p>Merit Mile formalized the visual identity within a comprehensive brand guide that brought the company story, values, voice, messaging pillars, logo hierarchy, visual system, and application standards into one practical resource. This established a consistent foundation for internal teams and external partners while giving LifeSync the flexibility to communicate across corporate, clinical, technical, and sales environments.</p>
                </div>
                <div className="col-12 col-md-6 text-center">
                    <img
                    src="https://www.meritmile.com/uploads/2026/08/lifesync-brand-guidelines.webp"
                    className=""
                    alt="LifeSync Photo & Video Shoot"
                    width="500px"
                    style={{
                        marginTop: "1em",
                        marginBottom: "4em",
                    }}
                    />
                </div>
                </div>
        </div>
    </div>
    <div className="container detail-wrapper">
        <div className="row margin-b">
          <div className="col-12 text-center margin-b">
            <img
              src="https://www.meritmile.com/uploads/2026/08/lifesync-visual-identity-scaled.webp"
              className="results-image img-fluid"
              alt="LifeSync Messaging"
              width="1400px"
              style={{ marginBottom: "2em", transform: "scale(1.2)" }}
            />
          </div>
        </div>
        <div className="row margin-b">
          <div className="col-md-6">
            <img
              src="https://www.meritmile.com/uploads/2026/08/lifesync-photo-video-shoot.webp"
              className="results-image img-fluid"
              alt="LifeSync Photo & Video Shoot"
              width="800px"
              style={{
                marginTop: "1em",
                marginBottom: "4em",
              }}
            />
          </div>
          <div className="col-md-6">
            <p>
                <b>Photo and Video Shoot</b><br />
                To give the new brand an authentic visual language that expressed LifeSync's clinical focus and advanced manufacturing expertise, Merit Mile led an on-site photography and video shoot at LifeSync’s Coral Springs facility and FIU’s Herbert Wertheim College of Medicine. The effort extended well beyond the shoot itself. Merit Mile managed creative strategy, location scouting, detailed shot and prop list development, scheduling, catering, and on-site coordination across LifeSync, FIU, and the production team.
            </p>
            <p>The dual-location production included hiring 12 on-camera talent for the full-day FIU shoot and extensive coordination of people, products, props, wardrobe, and shot lists across both sites. Following production, Merit Mile managed image and footage selection, shortlisting the strongest assets and overseeing editing and color correction to create a polished, ownable library of photography and b-roll video rooted in real people, environments, products, and processes. The client-owned library became a visual foundation for LifeSync 3.0, extending across LifeSync.com, the customer presentation, brochures, and supporting marketing materials while providing a flexible resource for future use.</p>
          </div>
        </div>
        <div className="row margin-b">
          <div className="col-12">
            <p>
              <b>Content Marketing</b><br />
              The strategy then moved from messaging and branding to go-to-market and product marketing. Merit Mile translated the new brand and messaging into marketing collateral including presentations, a corporate brochure, and line of business materials. The corporate brochure unified LifeSync’s overarching story, while dedicated Patient Connections and Advanced Manufacturing brochures allowed each line of business to communicate with the depth, proof, and tone its audience required.
            </p>
          </div>
        </div>
        <div className="row">
          <div className="col-12 text-center">
            <img
              src="https://www.meritmile.com/uploads/2026/08/lifesync-content-marketing-scaled.webp"
              className="results-image img-fluid"
              alt="LifeSync Content Marketing"
              width="1400px"
              style={{
                marginTop: "2em",
                marginBottom: "6em",
                transform: "scale(1.2)",
              }}
            />
          </div>
        </div>
        <div className="row margin-b">
          <div className="col-12 col-md-6">
            <p>
              <b>Web</b><br />
              Building on Merit Mile's development of the LifeSync 2.0 website and years of experience with the brand, audiences, and portfolio, LifeSync.com became the culmination of the 3.0 transformation. A user journey experience study informed new homepage navigation and information architecture, creating clearer pathways from visitor needs to the appropriate LifeSync solution. Dedicated line-of-business and innovation pages gave the portfolio clearer structure, while a minimalist, grid-based design, purposeful white space, and original photography and artwork created a more focused and credible digital presence. Merit Mile led wireframing, UX/UI design, copywriting, Shopify development, user acceptance testing, and launch.
            </p>
          </div>
          <div className="col-12 col-md-6 text-center">
            <img
              src="https://www.meritmile.com/uploads/2026/08/lifesync-web.webp"
              width=""
              alt="LifeSync Web"
              style={{ marginBottom: "2em", maxWidth: "100%" }}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <h3 style={{ marginBottom: '0'}}>Results</h3>
          </div>
        </div>
    </div>
    <div className="fullWidthGrayCTA margin-b">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h5>
                LifeSync 3.0 went to market with much more than a refreshed identity. <b>It entered the market with a unified brand system capable of carrying one clear story across audiences, channels, and lines of business</b>.
              </h5>
            </div>
          </div>
        </div>
      </div>
    <div className="container detail-wrapper">
        <div className="row margin-b">
          <div className="col-12 col-md-6">
            <ul style={{lineHeight: '1.2em;'}}>
                <li><b>Unified messaging and tools</b>: The messaging framework and brand guide established a consistent narrative and visual system, while the customer presentation and brochures equipped teams with polished sales and marketing tools.</li>
                <li><b>Clearer digital journeys</b>: The refreshed website created distinct paths for healthcare providers and OEMs, helping each audience understand LifeSync’s capabilities in context and move toward relevant solutions.</li>
            </ul>
          </div>
          <div className="col-12 col-md-6">
            <ul style={{lineHeight: '1.2em;'}}>
                <li><b>Cohesive visual experience</b>: Original photography and footage extended across the website, customer presentation, brochures, and other applications, creating a credible, ownable visual experience specific to LifeSync.</li>
                <li><b>Connected brand platform</b>: Together, the work brought messaging, visuals, sales tools, and digital experience into one system for communicating who LifeSync is, what differentiates its businesses, and how its solutions support customers.</li>
            </ul>
          </div>
        </div>
        <div className="row margin-b">
          <div className="col-12">
            <h3>Conclusion</h3>
            <p>
              LifeSync 3.0 demonstrates what becomes possible when messaging, visual identity, content, and digital experiences are developed as one connected system. Every element—from the positioning framework and brand guide to the website, customer presentation, brochures, and original visual content—was designed to reinforce the same strategic story.
            </p>
            <p>
                By combining high-level brand strategy with detailed creative, digital, and production execution, Merit Mile helped LifeSync bring its next chapter to market with greater clarity, consistency, and confidence. LifeSync now has an ownable brand foundation and a complete set of tools for communicating its value across customer conversations, digital experiences, and future marketing initiatives.
            </p>
          </div>
        </div>
        <div className="row">
          <div className="col-12 text-center">
            <img
              src="https://www.meritmile.com/uploads/2026/08/lifesync-production.webp"
              className="results-image img-fluid"
              alt="LifeSync Photo And Video Production"
              width="1400px"
              style={{
                marginTop: "2em",
                marginBottom: "6em",
                transform: "scale(1.2)",
              }}
            />
          </div>
        </div>
      </div>
      <div className="fullWidthGrayCTA">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h5>
                To start a conversation with Merit Mile, please drop us a line at <a href="mailto:Hello@MeritMile.com?subject=Lifesync%20Case%20Study%20Inquiry">
                  <b style={{ color: "black", textDecoration: "underline" }}>Hello@MeritMile.com</b>
                </a> or 561-362-8888. To learn more about LifeSync, please visit <a href="https://lifesync.com/" target="_blank"><b style={{ color: "black", textDecoration: "underline" }}>https://lifesync.com/</b></a>.
              </h5>
            </div>
          </div>
        </div>
      </div>
      <div className="fullWidthImageWrapper">
        <img
          src="https://www.meritmile.com/uploads/2021/09/mm-divider.jpg"
          alt="Merit Mile Icon Divider"
          className="img-fluid"
        />
      </div>
      <div className="about-wrapper">
        <div className="container">
          <div className="row">
            <div className="col">
              <h2>About Merit Mile</h2>
            </div>
          </div>
          <div className="row margin-b">
            <div className="col-md-6">
              <p>
                Established in 2007 in Boca Raton, FL, Merit Mile is a marketing
                services provider focused on helping companies and corporate
                marketing departments build brands, drive sales revenue, and
                garner publicity in their respective industries. Our unique
                differentiator at Merit Mile is our ability to 100% own the
                message, the publicity, and the demand generation aspects of the
                corporate marketing function. Clients hire us and rehire us for
                our ability to refine their messaging/value proposition, develop
                top and mid-funnel leads, and get the type of editorial
                publicity that differentiates them from their competitors. From
                branding to PR to demand generation, Merit Mile is the
                high-octane fuel that invigorates corporate growth engines. To
                learn more, please email us at Hello@MeritMile.com, call us at
                1-561-362-888, or visit us at www.MeritMile.com.{" "}
              </p>
            </div>
            <div className="col-md-6">
              <img
                className="img-fluid"
                src="https://www.meritmile.com/uploads/2021/06/mm-headquarter.webp"
                alt="Merit Mile Headquarter in Boca Raton, FL"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="container quote-wrapper">
        <div className="row">
          <div className="col-12">
            <p>
              For more insights and to connect
              <br />
              with Merit Mile{" "}
              <a href="mailto:Hello@MeritMile.com?subject=Teldoc%20Health%20Microsoft%20Case%20Study%20Inquiry">
                <b style={{ color: "black" }}>email us here</b>
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </Layout>
)
